<template>
  <lay-layout class="not-found-layout" :style="{'height': (height  - 82 - 42) + 'px'}">
    <lay-body :style="{'width': width + 'px'}">
      <lay-empty description="页面加载失败，请稍后重试。"></lay-empty>
    </lay-body>
  </lay-layout>
</template>

<script setup>
import {useSize} from "@/assets/js/size";
const {height, width} = useSize()
</script>

<style scoped>
.not-found-layout .layui-body {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>